import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import FormItem from '../../components/form/FormItem'
import { MdTitle } from 'react-icons/md'
import { BiX } from 'react-icons/bi'
import { Button, Form } from 'reactstrap'
import { fetchLanguageGet } from '../../redux/slices/languageGetSlice'
import { fetchLanguageCreate } from '../../redux/slices/languageCreateSlice'
import { fetchLanguageUpdate } from '../../redux/slices/languageUpdateSlice'
import DragDropFiles from '../../components/form/DragDropFiles'

const CrudLanguage = ({ showMenu, setShowMenu, setChanged, setSelectedItem, selectedItem, t }) => {
    const [formData, setFormData] = useState({ files: [], lang: "", langEN: "", code: "", zipCode: "" })
    const dispatch = useDispatch()

    const getData = async () => {
        if (selectedItem !== 0) {
            var data = await dispatch(fetchLanguageGet({ id: selectedItem }))
            if (data.payload) {
                var data = data.payload
                setFormData({ files: data?.files, lang: data?.lang?.tr, langen: data?.lang?.en, code: data?.code, zipCode: data?.zipCode })
            }
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        const lang = { "tr": formData.lang, "en": formData.lang }
        const code = formData.code.toLowerCase()
        await dispatch(
            selectedItem === 0 ?
                fetchLanguageCreate({ file: formData.files, lang: lang, code: code, zipCode: formData.zipCode }) :
                fetchLanguageUpdate({ id: selectedItem, file: formData.files, lang: lang, code: code, zipCode: formData.zipCode })
        )
        setChanged(true)
        getData()
        setShowMenu(false)
    }

    const closeModal = () => {
        setFormData({ files: [], lang: "", langEN: "", code: "", zipCode: "" })
        setShowMenu(!showMenu)
        setSelectedItem(0)
    }

    useEffect(() => { getData() }, [dispatch, selectedItem])

    return (
        <div className={showMenu ? 'right-popup' : 'd-none'}>
            <div className='right-popup-close' onClick={closeModal}><BiX size={24} /></div>
            <div className='right-popup-menu'>
                <div className='mb-3 text-center'><h5>{t(selectedItem === 0 ? "page_add" : "page_edit")}</h5></div>
                <Form onSubmit={handleSubmit}>
                    <DragDropFiles selectedItem={selectedItem} formData={formData} setFormData={setFormData} />

                    <FormItem
                        id="language"
                        name="language"
                        type="text"
                        icon={<MdTitle size={20} />}
                        title={t("language")}
                        formData={formData}
                        setFormData={setFormData}
                        keyT="lang"
                    />
                    <FormItem
                        id="code"
                        name="code"
                        type="text"
                        icon={<MdTitle size={20} />}
                        title={t("code")}
                        formData={formData}
                        setFormData={setFormData}
                        keyT="code"
                    />
                    <FormItem
                        id="zipCode"
                        name="zipCode"
                        type="text"
                        icon={<MdTitle size={20} />}
                        title={t("zipCode")}
                        formData={formData}
                        setFormData={setFormData}
                        keyT="zipCode"
                    />

                    <div className='d-flex justify-content-end mt-4 w-100'>
                        <Button type='submit' color={selectedItem === 0 ? 'primary' : 'warning'} className="text-white">
                            {t(selectedItem === 0 ? "add" : "edit")}
                        </Button>
                    </div>
                </Form>
            </div>
        </div>
    )
}

export default CrudLanguage
